import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const size = {
  extraSmall: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_11618_7399)">
        <path
          d="M6 2.89773V1.125C8.69239 1.125 10.875 3.30761 10.875 6C10.875 8.69239 8.69239 10.875 6 10.875C3.30761 10.875 1.125 8.69239 1.125 6C1.125 4.82147 1.5432 3.74061 2.2393 2.89773"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.33016 5.59473C6.54607 5.81979 6.53867 6.17726 6.31361 6.39318C6.08855 6.6091 5.73107 6.60169 5.51516 6.37664C5.29924 6.15158 5.30665 5.7941 5.5317 5.57818C5.75676 5.36227 6.11424 5.36967 6.33016 5.59473Z"
          fill="currentColor"
        />
        <path
          d="M3.97616 3.54896C4.08412 3.66149 4.08041 3.84023 3.96789 3.94819C3.85536 4.05615 3.67662 4.05244 3.56866 3.93991C3.4607 3.82739 3.46441 3.64865 3.57693 3.54069C3.68946 3.43273 3.8682 3.43643 3.97616 3.54896Z"
          fill="currentColor"
        />
        <path
          d="M5.51516 6.37664L3.56866 3.93991L3.97616 3.54896L6.33016 5.59473L5.51516 6.37664Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 3.86364V1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 6.42862 2.0576 4.98748 2.98574 3.86364"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.4404 7.45994C8.72829 7.76002 8.71841 8.23666 8.41834 8.52455C8.11827 8.81244 7.64163 8.80256 7.35374 8.50249C7.06584 8.20241 7.07572 7.72577 7.3758 7.43788C7.67587 7.14999 8.15251 7.15987 8.4404 7.45994Z"
        fill="currentColor"
      />
      <path
        d="M5.30174 4.73225C5.44568 4.88229 5.44075 5.12061 5.29071 5.26455C5.14067 5.4085 4.90235 5.40356 4.75841 5.25352C4.61446 5.10349 4.6194 4.86517 4.76944 4.72122C4.91947 4.57728 5.15779 4.58221 5.30174 4.73225Z"
        fill="currentColor"
      />
      <path d="M7.35374 8.50249L4.75841 5.25352L5.30174 4.73225L8.4404 7.45994L7.35374 8.50249Z" fill="currentColor" />
    </svg>
  ),
  default: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 5.79545V2.25C17.3848 2.25 21.75 6.61522 21.75 12C21.75 17.3848 17.3848 21.75 12 21.75C6.61522 21.75 2.25 17.3848 2.25 12C2.25 9.64293 3.0864 7.48121 4.47861 5.79545"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6606 11.1899C13.0925 11.64 13.0776 12.355 12.6275 12.7868C12.1774 13.2186 11.4625 13.2038 11.0306 12.7537C10.5988 12.3036 10.6136 11.5886 11.0637 11.1568C11.5138 10.725 12.2288 10.7398 12.6606 11.1899Z"
        fill="currentColor"
      />
      <path
        d="M7.95262 7.09836C8.16854 7.32342 8.16113 7.6809 7.93608 7.89681C7.71102 8.11273 7.35354 8.10532 7.13763 7.88027C6.92171 7.65521 6.92912 7.29773 7.15417 7.08182C7.37923 6.8659 7.73671 6.87331 7.95262 7.09836Z"
        fill="currentColor"
      />
      <path d="M11.0306 12.7537L7.13763 7.88027L7.95262 7.09836L12.6606 11.1899L11.0306 12.7537Z" fill="currentColor" />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 7.72727V3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16C3 12.8572 4.11521 9.97495 5.97147 7.72727"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8808 14.9199C17.4566 15.52 17.4368 16.4733 16.8367 17.0491C16.2365 17.6249 15.2833 17.6051 14.7075 17.005C14.1317 16.4048 14.1514 15.4515 14.7516 14.8758C15.3517 14.3 16.305 14.3197 16.8808 14.9199Z"
        fill="currentColor"
      />
      <path
        d="M10.6035 9.46449C10.8914 9.76456 10.8815 10.2412 10.5814 10.5291C10.2813 10.817 9.8047 10.8071 9.51681 10.507C9.22892 10.207 9.2388 9.73032 9.53887 9.44243C9.83895 9.15454 10.3156 9.16441 10.6035 9.46449Z"
        fill="currentColor"
      />
      <path d="M14.7075 17.005L9.51681 10.507L10.6035 9.46449L16.8808 14.9199L14.7075 17.005Z" fill="currentColor" />
    </svg>
  ),
} as const;

function BasicTimerIcon(props: SvgIconProps) {
  const item = size[props.fontSize as keyof typeof size] || size.default;
  return <SvgIcon {...props}>{item}</SvgIcon>;
}
export default BasicTimerIcon;
